import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const ACTION = "detail-list-summary-action asset-detail-summary-edit";

function isEnabledAction(value) {
    return value != null && value !== false && value !== "";
}

/**
 * 상세 summary bar 액션 — 저장·수정·삭제·이동
 */
export function DetailRollupActions({
    create,
    update,
    remove,
    movePage,
    updateTitle,
    createTitle,
}) {
    const navigate = useNavigate();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.altKey && event.key === "Enter" && isEnabledAction(create)) {
                create();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [create, navigate]);

    return (
        <>
            {isEnabledAction(create) && (
                <button
                    type="button"
                    className={ACTION}
                    onClick={() => {
                        if (window.confirm("등록 하시겠습니까?")) create();
                    }}
                >
                    {createTitle ?? "저장"}
                </button>
            )}
            {isEnabledAction(update) && (
                <button
                    type="button"
                    className={ACTION}
                    onClick={() => {
                        if (window.confirm(`${updateTitle ?? "수정"} 완료합니다.`)) update();
                    }}
                >
                    {updateTitle ?? "수정"}
                </button>
            )}
            {isEnabledAction(movePage) && (
                <button
                    type="button"
                    className={ACTION}
                    onClick={() => {
                        if (window.confirm(`[${movePage.content}] 이동하시겠습니까?`)) navigate(movePage.url);
                    }}
                >
                    {movePage.content}
                </button>
            )}
            {isEnabledAction(remove) && (
                <button
                    type="button"
                    className={`${ACTION} is-danger`}
                    onClick={() => {
                        if (window.confirm("삭제 하시겠습니까?")) remove();
                    }}
                >
                    삭제
                </button>
            )}
        </>
    );
}
